import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const SECTIONS = [
  { title: "Personal", fields: [
    { key: "first_name", label: "First Name", half: true },
    { key: "last_name", label: "Last Name", half: true },
    { key: "preferred_name", label: "Preferred Name" },
  ]},
  { title: "Contact", fields: [
    { key: "email", label: "Email", readOnly: true },
    { key: "phone", label: "Phone", half: true },
    { key: "town", label: "Town", half: true },
  ]},
  { title: "Emergency Contact", fields: [
    { key: "emergency_contact", label: "Name", half: true },
    { key: "emergency_relationship", label: "Relationship To You", half: true },
    { key: "emergency_email", label: "Their Email", half: true },
    { key: "emergency_phone", label: "Their Cell", half: true },
  ]},
  { title: "Background", fields: [
    { key: "status", label: "Status", select: ["Student", "Working", "Retired", "Other"] },
    { key: "how_heard", label: "How did you hear about Crew Call?", multiline: true },
    { key: "experience", label: "Experience", multiline: true },
  ]},
];

const inputCls = "bg-black border-zinc-700 focus-visible:ring-crew-yellow text-white rounded-sm";

const FieldInput = ({ f, value, onChange }) => {
  if (f.select) return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger className={inputCls} data-testid={`profile-${f.key}-input`}><SelectValue placeholder="Select" /></SelectTrigger>
      <SelectContent className="bg-zinc-900 border-zinc-700">
        {f.select.map((o) => <SelectItem key={o} value={o} className="text-white">{o}</SelectItem>)}
      </SelectContent>
    </Select>
  );
  const Comp = f.multiline ? Textarea : Input;
  return <Comp value={value || ""} onChange={(e) => onChange(e.target.value)} className={inputCls} data-testid={`profile-${f.key}-input`} />;
};

const Field = ({ f, form, setForm, editing }) => (
  <div className={f.half ? "col-span-1" : "col-span-2"}>
    <Label className="text-zinc-500 font-bold uppercase text-[11px] tracking-wider">{f.label}</Label>
    {editing && !f.readOnly ? (
      <div className="mt-1.5"><FieldInput f={f} value={form[f.key]} onChange={(v) => setForm({ ...form, [f.key]: v })} /></div>
    ) : (
      <p className="mt-1 text-white whitespace-pre-wrap break-words" data-testid={`profile-${f.key}-value`}>
        {form[f.key] || <span className="text-zinc-600">—</span>}
      </p>
    )}
    {editing && f.readOnly && (
      <p className="text-xs text-zinc-500 mt-1" data-testid="profile-email-note">
        To change your email, contact <a href="mailto:VPT@westportlibrary.org" className="text-crew-yellow underline">VPT@westportlibrary.org</a>
      </p>
    )}
  </div>
);

export const ProfileFields = ({ form, setForm, editing }) => (
  <div className="space-y-8">
    {SECTIONS.map((s) => (
      <section key={s.title}>
        <h3 className="text-crew-yellow text-sm font-bold uppercase tracking-tight border-b border-zinc-800 pb-2 mb-4">{s.title}</h3>
        <div className="grid grid-cols-2 gap-x-4 gap-y-5">
          {s.fields.map((f) => <Field key={f.key} f={f} form={form} setForm={setForm} editing={editing} />)}
        </div>
      </section>
    ))}
  </div>
);
